import { useEffect, useRef } from "react";
import { Modal } from "bootstrap";
import * as signalR from "@microsoft/signalr";
import signalRService from "../services/signalRService";
import { useActiveOrder } from "../utils/ActiveOrderContext";
import { getUserToken } from "../utils/tokenUtils";
import FeedbackModal from "../popupPages/FeedbackModal";

function ActiveOrderBarSignalR() {
  const { activeOrders, updateOrderStatus, refreshActiveOrder, deliveredOrder, clearDeliveredOrder } = useActiveOrder();
  const joinedRef = useRef(false);

  useEffect(() => {
    if (!deliveredOrder) return;
    const el = document.getElementById("feedbackModalDelivery");
    if (!el) return;
    const modal = Modal.getOrCreateInstance(el);
    modal.show();
    const onHidden = () => clearDeliveredOrder();
    el.addEventListener("hidden.bs.modal", onHidden);
    return () => el.removeEventListener("hidden.bs.modal", onHidden);
  }, [deliveredOrder, clearDeliveredOrder]);

  useEffect(() => {
    const token = getUserToken();
    if (!token) return;

    const joinGroup = () => {
      signalRService.invoke("JoinCustomerGroup", token.userId).catch(console.error);
    };

    signalRService.start().then(() => {
      if (!joinedRef.current) {
        joinedRef.current = true;
        joinGroup();
      }

      signalRService.on<[{ gOrder: string | null; id: string; orderStatusNameTr: string; orderStatusNameEn: string }]>(
        "OrderStatusUpdated",
        (update) => {
          updateOrderStatus(update.orderStatusNameTr, update.orderStatusNameEn);
        }
      );

      signalRService.onreconnected(() => {
        joinGroup();
        refreshActiveOrder();
      });
    });

    const handleVisibilityChange = () => {
      if (document.visibilityState !== "visible") return;
      if (signalRService.state !== signalR.HubConnectionState.Connected) {
        joinedRef.current = false;
        signalRService.start().then(() => {
          if (!joinedRef.current) {
            joinedRef.current = true;
            joinGroup();
          }
          refreshActiveOrder();
        });
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      signalRService.off("OrderStatusUpdated");
      signalRService.invoke("LeaveCustomerGroup", token.userId).catch(() => {});
      signalRService.stop();
      joinedRef.current = false;
    };
  }, [updateOrderStatus, refreshActiveOrder]);

  if (activeOrders.length === 0 && !deliveredOrder) return null;

  return (
    <FeedbackModal
      id="feedbackModalDelivery"
      order={deliveredOrder}
      restaurantName={deliveredOrder?.restourant?.restourantName ?? ""}
      onSuccess={() => {}}
    />
  );
}

export default ActiveOrderBarSignalR;
